import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@/core/api/client';

type AcceptInviteSignupRequest = {
  token: string;
  firstName: string;
  lastName: string;
  email: string;
};

type AcceptInviteSignupResponse = {
  message: string;
  email: string;
  redirectUrl?: string;
  referralMessage?: string;
};

/**
 * Hook to accept SP client invitation and create account
 * Public endpoint - no authentication required
 */
export function useAcceptInviteSignup(options?: {
  onSuccess?: (data: AcceptInviteSignupResponse) => void;
  onError?: (error: any) => void;
}) {
  return useMutation({
    mutationFn: async (data: AcceptInviteSignupRequest) => {
      const response = await apiClient.post<AcceptInviteSignupResponse>(
        `/sp-invitations/${data.token}/accept-signup`,
        {
          firstName: data.firstName,
          lastName: data.lastName,
          email: data.email,
        }
      );
      return response.data;
    },
    onSuccess: options?.onSuccess,
    onError: options?.onError,
  });
}
